var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-alert',{attrs:{"type":_vm.alertType,"closable":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.action.message || _vm.$t('flowTemplate.config.missing'))}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }